import {
    createRouter,
    createWebHistory
} from 'vue-router';

// 首页index
const home = () =>
    import( /* webpackChunkName: "home" */ '../pages/home.vue');

// 测试使用
const tt = () =>
    import( /* webpackChunkName: "tt" */ '../pages/ttt/tt.vue');


// 1. 公开暖玉官网
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
const public_home = () =>
    import( /* webpackChunkName: "public_home" */ '../pages/public/home.vue');
const p = () =>
    import( /* webpackChunkName: "p" */ '../pages/public/p.vue');
const public_like = () =>
    import( /* webpackChunkName: "public_like" */ '../pages/public/like.vue');
const public_buyer_show = () =>
    import( /* webpackChunkName: "public_buyer_show" */ '../pages/public/buyer_show.vue');
const public_knowledge = () =>
    import( /* webpackChunkName: "public_knowledge" */ '../pages/public/knowledge.vue');
const public_jewelry_all = () =>
    import( /* webpackChunkName: "public_jewelry_all" */ '../pages/public/jewelry/all.vue');
const public_jewelry_beads = () =>
    import( /* webpackChunkName: "public_jewelry_beads" */ '../pages/public/jewelry/beads.vue');
const public_jewelry_rings = () =>
    import( /* webpackChunkName: "public_jewelry_rings" */ '../pages/public/jewelry/rings.vue');
const public_jewelry_bracelets = () =>
    import( /* webpackChunkName: "public_jewelry_bracelets" */ '../pages/public/jewelry/bracelets.vue');
const public_jewelry_accessories = () =>
    import( /* webpackChunkName: "public_jewelry_accessories" */ '../pages/public/jewelry/accessories.vue');
const public_product_detail = () =>
    import( /* webpackChunkName: "public_product_detail" */ '../pages/public/product_detail.vue');
const public_chatgpt = () =>
    import( /* webpackChunkName: "public_chatgpt" */ '../pages/public/chatgpt.vue');
const public_tb_nuanyu = () =>
    import( /* webpackChunkName: "public_tb_nuanyu" */ '../pages/public/tb/nuanyu.vue');
const public_tb_nuanyu1 = () =>
    import( /* webpackChunkName: "public_tb_nuanyu1" */ '../pages/public/tb/nuanyu1.vue');
const public_tb_yueyue = () =>
    import( /* webpackChunkName: "public_tb_yueyue" */ '../pages/public/tb/yueyue.vue');
const public_tb_yueyue1 = () =>
    import( /* webpackChunkName: "public_tb_yueyue1" */ '../pages/public/tb/yueyue1.vue');
const public_discount = () =>
    import( /* webpackChunkName: "public_discount" */ '../pages/public/discount.vue');

// 公开的小工具
const WheelView = () =>
    import( /* webpackChunkName: "WheelView" */ '../pages/public/tools/wheel/WheelView.vue');
const SetPrizesView = () =>
    import( /* webpackChunkName: "SetPrizesView" */ '../pages/public/tools/wheel/SetPrizesView.vue');


// 2. 暖玉内部员工系统
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

// 00.数据查询系统 (库存表/出入库表/未还表/盘货表) (所有字段可筛选)
const staff_data = () =>
    import( /* webpackChunkName: "staff_data" */ '../pages/staff/data.vue');

// 00.上新系统  (产品属性编辑页)
// (包含上新录入/属性修改) (属性和图片的修改, 都可以用这个页面一站式解决)
const staff_submit = () =>
    import( /* webpackChunkName: "staff_submit" */ '../pages/staff/submit.vue');

// 01.出入库系统
const staff_stock_batch = () =>
    import( /* webpackChunkName: "staff_stock_batch" */ '../pages/staff/stock_batch.vue');
// 02.盘货系统
const staff_stock_check = () =>
    import( /* webpackChunkName: "staff_stock_check" */ '../pages/staff/stock_check.vue');
// 03.库存分布图
const staff_map = () =>
    import( /* webpackChunkName: "staff_map" */ '../pages/staff/stock_map.vue');
// 04.成本价
const staff_costprice = () =>
    import( /* webpackChunkName: "staff_costprice" */ '../pages/staff/price_cost.vue');
// 05.售价
const staff_saleprice = () =>
    import( /* webpackChunkName: "staff_saleprice" */ '../pages/staff/price_sale.vue');
// 07.打印价签
const staff_print = () =>
    import( /* webpackChunkName: "staff_print" */ '../pages/staff/print.vue');
// 08.数据下载
const staff_download = () =>
    import( /* webpackChunkName: "staff_download" */ '../pages/staff/download.vue');


// 99.内部系统登录
const staff_login = () =>
    import( /* webpackChunkName: "staff_login" */ '../pages/staff/login.vue');







// 3. 待删
// =============================================================
// 内部员工使用的展示页面 (待删)
const private_all_products = () =>
    import( /* webpackChunkName: "private_all_products" */ '../pages/private/all_products.vue');
// 线下交易系统  (废弃)
const offline = () =>
    import( /* webpackChunkName: "offline" */ '../pages/offline/offline.vue');
const offline_entry = () =>
    import( /* webpackChunkName: "offline_entry" */ '../pages/offline/entry.vue');
const offline_list = () =>
    import( /* webpackChunkName: "offline_list" */ '../pages/offline/list.vue');
const offline_edit = () =>
    import( /* webpackChunkName: "offline_edit" */ '../pages/offline/edit.vue');
// =============================================================



const routes = [
    // 首页index
    {
        path: '/',
        component: home,
        meta: {
            requiresAuth: true
        },
        name: 'Home',
    },
    {
        path: '/tt',
        component: tt,
        name: 'tt',
    },




    // 1. 公开暖玉官网
    {
        path: '/home',
        component: public_home,
        name: 'public_home'
    },
    {
        path: '/p/:product_id',
        component: p,
        name: 'p',
        props: true
    },
    {
        path: '/like',
        component: public_like,
        name: 'public_like'
    },
    {
        path: '/buyer_show',
        component: public_buyer_show,
        name: 'public_buyer_show'
    },
    {
        path: '/knowledge',
        component: public_knowledge,
        name: 'public_knowledge'
    },
    {
        path: '/jewelry/all',
        component: public_jewelry_all,
        name: 'public_jewelry_all',
        // // 使用属性方式接收参数; 路由案例: http://localhost:8080/jewelry/all?search=6980,448,23
        props: (route) => {
            const search = route.query.search ? route.query.search.replace(/,/g, ' ') : '';
            return {
                query: search,
            };
        }
    },
    {
        path: '/jewelry/beads',
        component: public_jewelry_beads,
        name: 'public_jewelry_beads',
        // // 使用属性方式接收参数; 路由案例: http://localhost:8080/jewelry/beads?search=6980,448,23
        props: (route) => {
            const search = route.query.search ? route.query.search.replace(/,/g, ' ') : '';
            return {
                query: search,
                // ttt: route.query.initialStockStatusActive,
                // initialStockStatusActive: route.query.initialStockStatusActive==='true' || route.query.initialStockStatusActive==='',
                // initialPhotoStatusActive: route.query.initialPhotoStatusActive==='true' || route.query.initialPhotoStatusActive==='',
            };
        }
    },
    {
        path: '/jewelry/rings',
        component: public_jewelry_rings,
        name: 'public_jewelry_rings',
        // // 使用属性方式接收参数; 路由案例: http://localhost:8080/jewelry/rings?search=6980,448,23
        props: (route) => {
            const search = route.query.search ? route.query.search.replace(/,/g, ' ') : '';
            return {
                query: search,
                // initialStockStatusActive: route.query.initialStockStatusActive==='true' || route.query.initialStockStatusActive===null,
                // initialPhotoStatusActive: route.query.initialPhotoStatusActive==='true' || route.query.initialPhotoStatusActive===null,
            };
        }
    },
    {
        path: '/jewelry/bracelets',
        component: public_jewelry_bracelets,
        name: 'public_jewelry_bracelets',
        // // 使用属性方式接收参数; 路由案例: http://localhost:8080/jewelry/bracelets?search=6980,448,23
        props: (route) => {
            const search = route.query.search ? route.query.search.replace(/,/g, ' ') : '';
            return {
                query: search,
                // initialStockStatusActive: route.query.initialStockStatusActive==='true' || route.query.initialStockStatusActive===null,
                // initialPhotoStatusActive: route.query.initialPhotoStatusActive==='true' || route.query.initialPhotoStatusActive===null,
            };
        }
    },
    {
        path: '/jewelry/accessories',
        component: public_jewelry_accessories,
        name: 'public_jewelry_accessories'
    },
    {
        path: '/product/:product_id',
        component: public_product_detail,
        name: 'public_product_detail'
    },
    {
        path: '/chatgpt',
        component: public_chatgpt,
        name: 'public_chatgpt'
    },
    // { path: '/discount/', component: public_discount, name: 'public_discount' },
    {
        path: '/discount',
        component: public_discount,
        name: 'public_discount',
        // 使用属性方式接收参数; 路由案例: http://localhost:8080/discount?username=1&code=3
        props: route => ({
            username: route.query.username,
            code: route.query.code
        })
    },
    // 用一个更好记忆的路径去指向这个常用页面
    {
        path: '/ny',
        component: public_jewelry_beads,
        name: 'public_jewelry_beads_ny'
    },
    {
        path: '/i',
        component: public_jewelry_all,
        name: 'public_jewelry_all_2'
    },
    {
        path: '/nuanyu',
        component: public_tb_nuanyu,
        name: 'public_tb_nuanyu'
    },
    {
        path: '/nuanyu1',
        component: public_tb_nuanyu1,
        name: 'public_tb_nuanyu1'
    },
    {
        path: '/yueyue',
        component: public_tb_yueyue,
        name: 'public_tb_yueyue'
    },
    {
        path: '/yueyue1',
        component: public_tb_yueyue1,
        name: 'public_tb_yueyue1'
    },



    {
        path: '/wheel',
        component: WheelView,
        name: 'WheelView'
    },
    {
        path: '/prizes',
        component: SetPrizesView,
        name: 'SetPrizesView'
    },



    // 私人使用 (待删)
    {
        path: '/private/all_products',
        component: private_all_products,
        name: 'private_all_products',
        // // 使用属性方式接收参数; 路由案例: http://localhost:8080/private/all_products?search=6980,448,23
        props: (route) => {
            const search = route.query.search ? route.query.search.replace(/,/g, ' ') : '';
            return {
                query: search,
                // initialStockStatusActive: route.query.initialStockStatusActive==='true' || route.query.initialStockStatusActive===null,
                // initialPhotoStatusActive: route.query.initialPhotoStatusActive==='true' || route.query.initialPhotoStatusActive===null,
            };
        }
    },



    // 2. 内部员工系统
    // 00.数据查询系统 (库存表/出入库表/未还表/盘货表) (所有字段可筛选)
    {
        path: '/staff',
        component: staff_data,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/staff/data',
        component: staff_data,
        name: 'staff_data',
        meta: {
            requiresAuth: true
        }
    },
    // 00.上新系统  (产品属性编辑页)
    // (包含上新录入/属性修改) (属性和图片的修改, 都可以用这个页面一站式解决)
    {
        path: '/staff/submit',
        component: staff_submit,
        name: 'staff_submit',
        meta: {
            requiresAuth: true
        }
    },
    // 01.出入库系统
    {
        path: '/staff/stock_batch',
        component: staff_stock_batch,
        name: 'staff_stock_batch',
        meta: {
            requiresAuth: true
        }
    },
    // 02.盘货系统
    {
        path: '/staff/stock_check',
        component: staff_stock_check,
        name: 'staff_stock_check',
        meta: {
            requiresAuth: true
        }
    },
    // 03.库存分布图
    {
        path: '/staff/map',
        component: staff_map,
        name: 'staff_map',
        meta: {
            requiresAuth: true
        }
    },
    // 04.成本价
    {
        path: '/staff/costprice',
        component: staff_costprice,
        name: 'staff_costprice',
        meta: {
            requiresAuth: true
        }
    },
    // 05.售价
    {
        path: '/staff/saleprice',
        component: staff_saleprice,
        name: 'staff_saleprice',
        meta: {
            requiresAuth: true
        }
    },


    // 07.打印价签
    {
        path: '/staff/print',
        component: staff_print,
        name: 'staff_print',
        meta: {
            requiresAuth: true
        }
    },

    // 08.数据下载
    {
        path: '/staff/download',
        component: staff_download,
        name: 'staff_download',
        meta: {
            requiresAuth: true
        }
    },

    // 09.登录内部系统
    {
        path: '/staff/login',
        component: staff_login,
        name: 'staff_login',
    },






    // 线下交易系统 (废弃不用了)
    {
        path: '/offline/entry',
        component: offline_entry,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/offline/list',
        component: offline_list,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/offline/edit/:_id',
        component: offline_edit,
        meta: {
            requiresAuth: true
        }
    },



];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                top: 0
            };
        }
    }
});


// const router = createRouter({
//     history: createWebHistory(),
//     routes,
//     scrollBehavior(to, from, savedPosition) {
//         if (savedPosition) {
//             return savedPosition;
//         } else {
//             const position = localStorage.getItem('scrollPosition');
//             return position ? { top: parseInt(position) } : { top: 0 }; // 从 localStorage 获取位置
//         }
//     }
// });
// // 在每次路由切换时保存当前滚动位置
// router.afterEach((to, from) => {
//     localStorage.setItem('scrollPosition', window.scrollY.toString());
// });


// 用于特殊用户验证相关页面 (核心内部页面必须登录才能查看!)
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token'); // 从localStorage中获取token
    console.log('Navigating to:', to.path, 'Requires Auth:', to.meta.requiresAuth, 'Token:', token); // 调试信息
    if (to.matched.some(record => record.meta.requiresAuth) && !token) {
        // 如果目标路由需要认证且用户未登录，则重定向到登录页面
        next({
            path: '/staff/login',
            query: {
                redirect: to.fullPath
            }
        });
    } else {
        next(); // 否则继续导航
    }
});

export default router;
